import { EnvironmentType } from '../types';

const LABS_PRODUCTION = {
  NY: '5',
  SF: '8',
  LA: '11',
  LOS_ALTOS: '21',
  ATLANTA: '16',
  DISNEY: '24',
  PRINCETON: '12',
  AUSTIN: '22',
  DENVER: '25',
  MINNEAPOLIS: '27'
};

const LABS_STAGING = {
  NY: '7',
  SF: '9',
  LA: '15',
  LOS_ALTOS: '21',
  ATLANTA: '16',
  DISNEY: '24',
  PRINCETON: '12',
  AUSTIN: '22',
  DENVER: '25',
  MINNEAPOLIS: '27'
};

export function labs(env: EnvironmentType) {
  if (env === 'production' || env === 'uat') {
    return LABS_PRODUCTION;
  }
  return LABS_STAGING;
}

export function isDisneyPatient(env: EnvironmentType, labId: string): boolean {
  if (env === 'production' || env === 'uat') {
    return LABS_PRODUCTION.DISNEY === labId;
  }
  return LABS_STAGING.DISNEY === labId;
}
